import { BaseRouteReuseStrategy, ActivatedRouteSnapshot } from '@angular/router';
import { isEqual } from 'lodash';
import { FORCE_RELOAD_CHAT } from '../utils/constants';

export class RouteReuseService extends BaseRouteReuseStrategy {
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    const isChatRoute = future.data?.componentName === 'ChatComponent' && curr.data?.componentName === 'ChatComponent';
    if (isChatRoute) {
      const paramsChanged = !isEqual(future.params, curr.params);
      const reuse = future.queryParams['reuse'];
      const embedShowTimestamp = future.queryParams[FORCE_RELOAD_CHAT];
      if (embedShowTimestamp) {
        return false;
      }

      if (reuse) {
        return true;
      }
      if (paramsChanged) {
        return false;
      }
    }
    return super.shouldReuseRoute(future, curr);
  }
}
